import React, { useState } from 'react';
import Button from '../Button/Button';
import processDocument from '../../api/bank/processDocument';
import alert from '../../helpers/alert';

const ProcessDocumentButton = ({ chunkId, text = "ÐÐ¾Ð²ÑÐ¾ÑÐ½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÑ", buttonProps = {} }) => {
  const [loading, setLoading] = useState(false);
  
  const handleProcessDocument = async () => {
    if (!chunkId) {
      alert.error('chunkId Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½');
      return;
    }
    
    setLoading(true);
    try {
      await processDocument(chunkId);
      alert.success('ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ñ');
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²';
      alert.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  
  
  return (
    <Button 
      text={text}
      fill
      onClick={handleProcessDocument}
      {...buttonProps}
      loading={loading}
      disabled={loading}
    />
  );
};

export default ProcessDocumentButton; 